import { ArrowRightOutlined } from "@ant-design/icons";
import { Button, Flex } from "antd";
import { t } from "i18next";
import AkcizniProizvodi from "../../../../assets/images/loginPage/akcizni_proizvodi.png";
import InformacijeOSistemu from "../../../../assets/images/loginPage/informacije_o_sistemu.png";
import Placeholder from "../../../../assets/images/loginPage/placeholder.png";
import Propisi from "../../../../assets/images/loginPage/propisi.png";
import {
  LoginCardKey,
  LoginPageCard,
} from "../../../../modules/auth/auth.types";
import style from "./LoginCard.module.scss";

interface LoginCardProps {
  cardInfo: LoginPageCard;
  onClick: (slideNumber: number) => void;
}

const LoginCard = ({ cardInfo, onClick }: LoginCardProps) => {
  const getCardImage = (cardKey: LoginCardKey) => {
    switch (cardKey) {
      case LoginCardKey.AKCIZNI_PROIZVODI:
        return AkcizniProizvodi;
      case LoginCardKey.INFORMACIJE_O_SISTEMU:
        return InformacijeOSistemu;
      case LoginCardKey.PROPISI:
        return Propisi;
      default:
        return Placeholder;
    }
  };

  return (
    <Flex key={cardInfo.key} gap={24} className={style.card} vertical>
      <img
        src={getCardImage(cardInfo.key)}
        alt={cardInfo.title}
        className={style.cardImg}
      />
      <Flex vertical gap={8}>
        <span className={style.cardTitle}>{t(cardInfo.translationKey)}</span>
        <div className={style.cardText}>{t(cardInfo.textTranslationKey)}</div>
        <Button
          className={style.cardBtn}
          type="link"
          onClick={() => onClick?.(cardInfo?.slideNumber)}
        >
          <Flex gap={20}>
            {t("LOGIN.DETALJI")}
            <ArrowRightOutlined />
          </Flex>
        </Button>
      </Flex>
    </Flex>
  );
};

export default LoginCard;
